<template>
</template>

<script>
	export default{
		data(){
			this.$router.replace({
				path: '/design/stuLocation'
			})
			return{
				
			}
		},
		methods:{
			
		}
	}
</script>

<style>
</style>
